/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as EquityRouteImport } from "./routes/equity";
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password";
import { Route as LegalRouteImport } from "./routes/legal";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as NotificationsRouteImport } from "./routes/notifications";
import { Route as SettingsRouteRouteImport } from "./routes/settings/route";
import { Route as WorkRouteImport } from "./routes/work";
import { Route as DirectoryIndexRouteImport } from "./routes/directory/index";
import { Route as FinanceIndexRouteImport } from "./routes/finance/index";
import { Route as FinancePayablesRouteImport } from "./routes/finance/payables";
import { Route as FinanceReceivablesRouteImport } from "./routes/finance/receivables";
import { Route as FinanceReconciliationRouteImport } from "./routes/finance/reconciliation";
import { Route as IntakeIndexRouteImport } from "./routes/intake/index";
import { Route as IntakeFileIdRouteImport } from "./routes/intake/$fileId";
import { Route as OrganizationsNewRouteImport } from "./routes/organizations/new";
import { Route as PeopleIndexRouteImport } from "./routes/people/index";
import { Route as PeoplePersonIdRouteImport } from "./routes/people/$personId";
import { Route as SettingsIndexRouteImport } from "./routes/settings/index";
import { Route as SettingsApiKeysRouteImport } from "./routes/settings/api-keys";
import { Route as SettingsAuditLogRouteImport } from "./routes/settings/audit-log";
import { Route as SettingsIdentityRouteImport } from "./routes/settings/identity";
import { Route as SettingsLimitsRouteImport } from "./routes/settings/limits";
import { Route as SettingsProfileRouteImport } from "./routes/settings/profile";
import { Route as SettingsSecurityRouteImport } from "./routes/settings/security";
import { Route as SettingsTeamRouteImport } from "./routes/settings/team";
import { Route as DirectoryCustomersCustomerIdRouteImport } from "./routes/directory/customers/$customerId";
import { Route as DirectoryOtherPartyIdRouteImport } from "./routes/directory/other/$partyId";
import { Route as DirectoryVendorsVendorIdRouteImport } from "./routes/directory/vendors/$vendorId";
import { Route as SettingsRevolutIndexRouteImport } from "./routes/settings/revolut/index";
import { Route as SettingsRevolutCallbackRouteImport } from "./routes/settings/revolut/callback";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const EquityRoute = EquityRouteImport.update({
  id: "/equity",
  path: "/equity",
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any);
const LegalRoute = LegalRouteImport.update({
  id: "/legal",
  path: "/legal",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsRoute = NotificationsRouteImport.update({
  id: "/notifications",
  path: "/notifications",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any);
const WorkRoute = WorkRouteImport.update({
  id: "/work",
  path: "/work",
  getParentRoute: () => rootRouteImport,
} as any);
const DirectoryIndexRoute = DirectoryIndexRouteImport.update({
  id: "/directory/",
  path: "/directory/",
  getParentRoute: () => rootRouteImport,
} as any);
const FinanceIndexRoute = FinanceIndexRouteImport.update({
  id: "/finance/",
  path: "/finance/",
  getParentRoute: () => rootRouteImport,
} as any);
const FinancePayablesRoute = FinancePayablesRouteImport.update({
  id: "/finance/payables",
  path: "/finance/payables",
  getParentRoute: () => rootRouteImport,
} as any);
const FinanceReceivablesRoute = FinanceReceivablesRouteImport.update({
  id: "/finance/receivables",
  path: "/finance/receivables",
  getParentRoute: () => rootRouteImport,
} as any);
const FinanceReconciliationRoute = FinanceReconciliationRouteImport.update({
  id: "/finance/reconciliation",
  path: "/finance/reconciliation",
  getParentRoute: () => rootRouteImport,
} as any);
const IntakeIndexRoute = IntakeIndexRouteImport.update({
  id: "/intake/",
  path: "/intake/",
  getParentRoute: () => rootRouteImport,
} as any);
const IntakeFileIdRoute = IntakeFileIdRouteImport.update({
  id: "/intake/$fileId",
  path: "/intake/$fileId",
  getParentRoute: () => rootRouteImport,
} as any);
const OrganizationsNewRoute = OrganizationsNewRouteImport.update({
  id: "/organizations/new",
  path: "/organizations/new",
  getParentRoute: () => rootRouteImport,
} as any);
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: "/people/",
  path: "/people/",
  getParentRoute: () => rootRouteImport,
} as any);
const PeoplePersonIdRoute = PeoplePersonIdRouteImport.update({
  id: "/people/$personId",
  path: "/people/$personId",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsApiKeysRoute = SettingsApiKeysRouteImport.update({
  id: "/api-keys",
  path: "/api-keys",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsAuditLogRoute = SettingsAuditLogRouteImport.update({
  id: "/audit-log",
  path: "/audit-log",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsIdentityRoute = SettingsIdentityRouteImport.update({
  id: "/identity",
  path: "/identity",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsLimitsRoute = SettingsLimitsRouteImport.update({
  id: "/limits",
  path: "/limits",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: "/security",
  path: "/security",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const DirectoryCustomersCustomerIdRoute =
  DirectoryCustomersCustomerIdRouteImport.update({
    id: "/directory/customers/$customerId",
    path: "/directory/customers/$customerId",
    getParentRoute: () => rootRouteImport,
  } as any);
const DirectoryOtherPartyIdRoute = DirectoryOtherPartyIdRouteImport.update({
  id: "/directory/other/$partyId",
  path: "/directory/other/$partyId",
  getParentRoute: () => rootRouteImport,
} as any);
const DirectoryVendorsVendorIdRoute =
  DirectoryVendorsVendorIdRouteImport.update({
    id: "/directory/vendors/$vendorId",
    path: "/directory/vendors/$vendorId",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRevolutIndexRoute = SettingsRevolutIndexRouteImport.update({
  id: "/revolut/",
  path: "/revolut/",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const SettingsRevolutCallbackRoute = SettingsRevolutCallbackRouteImport.update({
  id: "/revolut/callback",
  path: "/revolut/callback",
  getParentRoute: () => SettingsRouteRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/settings": typeof SettingsRouteRouteWithChildren;
  "/equity": typeof EquityRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/legal": typeof LegalRoute;
  "/login": typeof LoginRoute;
  "/notifications": typeof NotificationsRoute;
  "/work": typeof WorkRoute;
  "/finance/payables": typeof FinancePayablesRoute;
  "/finance/receivables": typeof FinanceReceivablesRoute;
  "/finance/reconciliation": typeof FinanceReconciliationRoute;
  "/intake/$fileId": typeof IntakeFileIdRoute;
  "/organizations/new": typeof OrganizationsNewRoute;
  "/people/$personId": typeof PeoplePersonIdRoute;
  "/settings/api-keys": typeof SettingsApiKeysRoute;
  "/settings/audit-log": typeof SettingsAuditLogRoute;
  "/settings/identity": typeof SettingsIdentityRoute;
  "/settings/limits": typeof SettingsLimitsRoute;
  "/settings/profile": typeof SettingsProfileRoute;
  "/settings/security": typeof SettingsSecurityRoute;
  "/settings/team": typeof SettingsTeamRoute;
  "/directory/": typeof DirectoryIndexRoute;
  "/finance/": typeof FinanceIndexRoute;
  "/intake/": typeof IntakeIndexRoute;
  "/people/": typeof PeopleIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/directory/customers/$customerId": typeof DirectoryCustomersCustomerIdRoute;
  "/directory/other/$partyId": typeof DirectoryOtherPartyIdRoute;
  "/directory/vendors/$vendorId": typeof DirectoryVendorsVendorIdRoute;
  "/settings/revolut/callback": typeof SettingsRevolutCallbackRoute;
  "/settings/revolut/": typeof SettingsRevolutIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/equity": typeof EquityRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/legal": typeof LegalRoute;
  "/login": typeof LoginRoute;
  "/notifications": typeof NotificationsRoute;
  "/work": typeof WorkRoute;
  "/finance/payables": typeof FinancePayablesRoute;
  "/finance/receivables": typeof FinanceReceivablesRoute;
  "/finance/reconciliation": typeof FinanceReconciliationRoute;
  "/intake/$fileId": typeof IntakeFileIdRoute;
  "/organizations/new": typeof OrganizationsNewRoute;
  "/people/$personId": typeof PeoplePersonIdRoute;
  "/settings/api-keys": typeof SettingsApiKeysRoute;
  "/settings/audit-log": typeof SettingsAuditLogRoute;
  "/settings/identity": typeof SettingsIdentityRoute;
  "/settings/limits": typeof SettingsLimitsRoute;
  "/settings/profile": typeof SettingsProfileRoute;
  "/settings/security": typeof SettingsSecurityRoute;
  "/settings/team": typeof SettingsTeamRoute;
  "/directory": typeof DirectoryIndexRoute;
  "/finance": typeof FinanceIndexRoute;
  "/intake": typeof IntakeIndexRoute;
  "/people": typeof PeopleIndexRoute;
  "/settings": typeof SettingsIndexRoute;
  "/directory/customers/$customerId": typeof DirectoryCustomersCustomerIdRoute;
  "/directory/other/$partyId": typeof DirectoryOtherPartyIdRoute;
  "/directory/vendors/$vendorId": typeof DirectoryVendorsVendorIdRoute;
  "/settings/revolut/callback": typeof SettingsRevolutCallbackRoute;
  "/settings/revolut": typeof SettingsRevolutIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/settings": typeof SettingsRouteRouteWithChildren;
  "/equity": typeof EquityRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/legal": typeof LegalRoute;
  "/login": typeof LoginRoute;
  "/notifications": typeof NotificationsRoute;
  "/work": typeof WorkRoute;
  "/finance/payables": typeof FinancePayablesRoute;
  "/finance/receivables": typeof FinanceReceivablesRoute;
  "/finance/reconciliation": typeof FinanceReconciliationRoute;
  "/intake/$fileId": typeof IntakeFileIdRoute;
  "/organizations/new": typeof OrganizationsNewRoute;
  "/people/$personId": typeof PeoplePersonIdRoute;
  "/settings/api-keys": typeof SettingsApiKeysRoute;
  "/settings/audit-log": typeof SettingsAuditLogRoute;
  "/settings/identity": typeof SettingsIdentityRoute;
  "/settings/limits": typeof SettingsLimitsRoute;
  "/settings/profile": typeof SettingsProfileRoute;
  "/settings/security": typeof SettingsSecurityRoute;
  "/settings/team": typeof SettingsTeamRoute;
  "/directory/": typeof DirectoryIndexRoute;
  "/finance/": typeof FinanceIndexRoute;
  "/intake/": typeof IntakeIndexRoute;
  "/people/": typeof PeopleIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/directory/customers/$customerId": typeof DirectoryCustomersCustomerIdRoute;
  "/directory/other/$partyId": typeof DirectoryOtherPartyIdRoute;
  "/directory/vendors/$vendorId": typeof DirectoryVendorsVendorIdRoute;
  "/settings/revolut/callback": typeof SettingsRevolutCallbackRoute;
  "/settings/revolut/": typeof SettingsRevolutIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/settings"
    | "/equity"
    | "/forgot-password"
    | "/legal"
    | "/login"
    | "/notifications"
    | "/work"
    | "/finance/payables"
    | "/finance/receivables"
    | "/finance/reconciliation"
    | "/intake/$fileId"
    | "/organizations/new"
    | "/people/$personId"
    | "/settings/api-keys"
    | "/settings/audit-log"
    | "/settings/identity"
    | "/settings/limits"
    | "/settings/profile"
    | "/settings/security"
    | "/settings/team"
    | "/directory/"
    | "/finance/"
    | "/intake/"
    | "/people/"
    | "/settings/"
    | "/directory/customers/$customerId"
    | "/directory/other/$partyId"
    | "/directory/vendors/$vendorId"
    | "/settings/revolut/callback"
    | "/settings/revolut/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/equity"
    | "/forgot-password"
    | "/legal"
    | "/login"
    | "/notifications"
    | "/work"
    | "/finance/payables"
    | "/finance/receivables"
    | "/finance/reconciliation"
    | "/intake/$fileId"
    | "/organizations/new"
    | "/people/$personId"
    | "/settings/api-keys"
    | "/settings/audit-log"
    | "/settings/identity"
    | "/settings/limits"
    | "/settings/profile"
    | "/settings/security"
    | "/settings/team"
    | "/directory"
    | "/finance"
    | "/intake"
    | "/people"
    | "/settings"
    | "/directory/customers/$customerId"
    | "/directory/other/$partyId"
    | "/directory/vendors/$vendorId"
    | "/settings/revolut/callback"
    | "/settings/revolut";
  id:
    | "__root__"
    | "/"
    | "/settings"
    | "/equity"
    | "/forgot-password"
    | "/legal"
    | "/login"
    | "/notifications"
    | "/work"
    | "/finance/payables"
    | "/finance/receivables"
    | "/finance/reconciliation"
    | "/intake/$fileId"
    | "/organizations/new"
    | "/people/$personId"
    | "/settings/api-keys"
    | "/settings/audit-log"
    | "/settings/identity"
    | "/settings/limits"
    | "/settings/profile"
    | "/settings/security"
    | "/settings/team"
    | "/directory/"
    | "/finance/"
    | "/intake/"
    | "/people/"
    | "/settings/"
    | "/directory/customers/$customerId"
    | "/directory/other/$partyId"
    | "/directory/vendors/$vendorId"
    | "/settings/revolut/callback"
    | "/settings/revolut/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren;
  EquityRoute: typeof EquityRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  LegalRoute: typeof LegalRoute;
  LoginRoute: typeof LoginRoute;
  NotificationsRoute: typeof NotificationsRoute;
  WorkRoute: typeof WorkRoute;
  FinancePayablesRoute: typeof FinancePayablesRoute;
  FinanceReceivablesRoute: typeof FinanceReceivablesRoute;
  FinanceReconciliationRoute: typeof FinanceReconciliationRoute;
  IntakeFileIdRoute: typeof IntakeFileIdRoute;
  OrganizationsNewRoute: typeof OrganizationsNewRoute;
  PeoplePersonIdRoute: typeof PeoplePersonIdRoute;
  DirectoryIndexRoute: typeof DirectoryIndexRoute;
  FinanceIndexRoute: typeof FinanceIndexRoute;
  IntakeIndexRoute: typeof IntakeIndexRoute;
  PeopleIndexRoute: typeof PeopleIndexRoute;
  DirectoryCustomersCustomerIdRoute: typeof DirectoryCustomersCustomerIdRoute;
  DirectoryOtherPartyIdRoute: typeof DirectoryOtherPartyIdRoute;
  DirectoryVendorsVendorIdRoute: typeof DirectoryVendorsVendorIdRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/equity": {
      id: "/equity";
      path: "/equity";
      fullPath: "/equity";
      preLoaderRoute: typeof EquityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/forgot-password": {
      id: "/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/legal": {
      id: "/legal";
      path: "/legal";
      fullPath: "/legal";
      preLoaderRoute: typeof LegalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/notifications": {
      id: "/notifications";
      path: "/notifications";
      fullPath: "/notifications";
      preLoaderRoute: typeof NotificationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings": {
      id: "/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof SettingsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/work": {
      id: "/work";
      path: "/work";
      fullPath: "/work";
      preLoaderRoute: typeof WorkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/directory/": {
      id: "/directory/";
      path: "/directory";
      fullPath: "/directory/";
      preLoaderRoute: typeof DirectoryIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/finance/": {
      id: "/finance/";
      path: "/finance";
      fullPath: "/finance/";
      preLoaderRoute: typeof FinanceIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/finance/payables": {
      id: "/finance/payables";
      path: "/finance/payables";
      fullPath: "/finance/payables";
      preLoaderRoute: typeof FinancePayablesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/finance/receivables": {
      id: "/finance/receivables";
      path: "/finance/receivables";
      fullPath: "/finance/receivables";
      preLoaderRoute: typeof FinanceReceivablesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/finance/reconciliation": {
      id: "/finance/reconciliation";
      path: "/finance/reconciliation";
      fullPath: "/finance/reconciliation";
      preLoaderRoute: typeof FinanceReconciliationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/intake/": {
      id: "/intake/";
      path: "/intake";
      fullPath: "/intake/";
      preLoaderRoute: typeof IntakeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/intake/$fileId": {
      id: "/intake/$fileId";
      path: "/intake/$fileId";
      fullPath: "/intake/$fileId";
      preLoaderRoute: typeof IntakeFileIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/organizations/new": {
      id: "/organizations/new";
      path: "/organizations/new";
      fullPath: "/organizations/new";
      preLoaderRoute: typeof OrganizationsNewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/people/": {
      id: "/people/";
      path: "/people";
      fullPath: "/people/";
      preLoaderRoute: typeof PeopleIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/people/$personId": {
      id: "/people/$personId";
      path: "/people/$personId";
      fullPath: "/people/$personId";
      preLoaderRoute: typeof PeoplePersonIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/": {
      id: "/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/api-keys": {
      id: "/settings/api-keys";
      path: "/api-keys";
      fullPath: "/settings/api-keys";
      preLoaderRoute: typeof SettingsApiKeysRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/audit-log": {
      id: "/settings/audit-log";
      path: "/audit-log";
      fullPath: "/settings/audit-log";
      preLoaderRoute: typeof SettingsAuditLogRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/identity": {
      id: "/settings/identity";
      path: "/identity";
      fullPath: "/settings/identity";
      preLoaderRoute: typeof SettingsIdentityRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/limits": {
      id: "/settings/limits";
      path: "/limits";
      fullPath: "/settings/limits";
      preLoaderRoute: typeof SettingsLimitsRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/profile": {
      id: "/settings/profile";
      path: "/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof SettingsProfileRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/security": {
      id: "/settings/security";
      path: "/security";
      fullPath: "/settings/security";
      preLoaderRoute: typeof SettingsSecurityRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/team": {
      id: "/settings/team";
      path: "/team";
      fullPath: "/settings/team";
      preLoaderRoute: typeof SettingsTeamRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/directory/customers/$customerId": {
      id: "/directory/customers/$customerId";
      path: "/directory/customers/$customerId";
      fullPath: "/directory/customers/$customerId";
      preLoaderRoute: typeof DirectoryCustomersCustomerIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/directory/other/$partyId": {
      id: "/directory/other/$partyId";
      path: "/directory/other/$partyId";
      fullPath: "/directory/other/$partyId";
      preLoaderRoute: typeof DirectoryOtherPartyIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/directory/vendors/$vendorId": {
      id: "/directory/vendors/$vendorId";
      path: "/directory/vendors/$vendorId";
      fullPath: "/directory/vendors/$vendorId";
      preLoaderRoute: typeof DirectoryVendorsVendorIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/revolut/": {
      id: "/settings/revolut/";
      path: "/revolut";
      fullPath: "/settings/revolut/";
      preLoaderRoute: typeof SettingsRevolutIndexRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/settings/revolut/callback": {
      id: "/settings/revolut/callback";
      path: "/revolut/callback";
      fullPath: "/settings/revolut/callback";
      preLoaderRoute: typeof SettingsRevolutCallbackRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
  }
}

interface SettingsRouteRouteChildren {
  SettingsApiKeysRoute: typeof SettingsApiKeysRoute;
  SettingsAuditLogRoute: typeof SettingsAuditLogRoute;
  SettingsIdentityRoute: typeof SettingsIdentityRoute;
  SettingsLimitsRoute: typeof SettingsLimitsRoute;
  SettingsProfileRoute: typeof SettingsProfileRoute;
  SettingsSecurityRoute: typeof SettingsSecurityRoute;
  SettingsTeamRoute: typeof SettingsTeamRoute;
  SettingsIndexRoute: typeof SettingsIndexRoute;
  SettingsRevolutCallbackRoute: typeof SettingsRevolutCallbackRoute;
  SettingsRevolutIndexRoute: typeof SettingsRevolutIndexRoute;
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsApiKeysRoute: SettingsApiKeysRoute,
  SettingsAuditLogRoute: SettingsAuditLogRoute,
  SettingsIdentityRoute: SettingsIdentityRoute,
  SettingsLimitsRoute: SettingsLimitsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsRevolutCallbackRoute: SettingsRevolutCallbackRoute,
  SettingsRevolutIndexRoute: SettingsRevolutIndexRoute,
};

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  EquityRoute: EquityRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LegalRoute: LegalRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  WorkRoute: WorkRoute,
  FinancePayablesRoute: FinancePayablesRoute,
  FinanceReceivablesRoute: FinanceReceivablesRoute,
  FinanceReconciliationRoute: FinanceReconciliationRoute,
  IntakeFileIdRoute: IntakeFileIdRoute,
  OrganizationsNewRoute: OrganizationsNewRoute,
  PeoplePersonIdRoute: PeoplePersonIdRoute,
  DirectoryIndexRoute: DirectoryIndexRoute,
  FinanceIndexRoute: FinanceIndexRoute,
  IntakeIndexRoute: IntakeIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  DirectoryCustomersCustomerIdRoute: DirectoryCustomersCustomerIdRoute,
  DirectoryOtherPartyIdRoute: DirectoryOtherPartyIdRoute,
  DirectoryVendorsVendorIdRoute: DirectoryVendorsVendorIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
